import Vue from 'vue';
import colors from 'vuetify/es5/util/colors'
import Vuetify from 'vuetify/lib/framework';
import i18n from '@/plugins/i18n';

Vue.use(Vuetify)
const vuetify = new Vuetify({
    lang: {
      t: (key, ...params) => i18n.t(key, params),
    },
    iconfont: 'md',
    theme: {
      themes: {
        light: {
          primary: '#0069B3',//"#5D35B0",//"#593A8E",//"1B5E20",//colors.purple.darken4, // #4A148C //green darken-4
          secondary: colors.purple.lighten4, // #E1BEE7
          accent: colors.purple.accent1, // #EA80FC
          search: colors.grey.lighten2, // #E0E0E0
          searchButton: colors.green.lighten3,  // #A5D6A7
          newsBlock: colors.grey.lighten4, // #F5F5F5
          background : "F8F9FA"
          // info: colors.lighten1,
          // warning: colors.darken2,
          // error: colors.accent4,
          // success: colors.lighten2,
        },
        dark: {
          primary: '#0069B3',
          background: "#212121"
        }
      }
    }
  });

export default vuetify
